import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@catawiki/cata-style';
export const FooterLink = ({ as = 'a', ...rest }) => (_jsx(Button, { ...rest, as: as, color: "dark-gray", variant: "tertiary" }));
//# sourceMappingURL=FooterLink.js.map